import { render, staticRenderFns } from "./ShippedByFNS-Column.vue?vue&type=template&id=1b92eb66&"
import script from "./ShippedByFNS-Column.vue?vue&type=script&lang=js&"
export * from "./ShippedByFNS-Column.vue?vue&type=script&lang=js&"
import style0 from "./ShippedByFNS-Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports